import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import Select from 'react-select'
import PageLoader from '../../components/PageLoader/PageLoader'
import Paginate from '../../components/pagination/paginate'
import { appAllGetHubs } from '../../store/hubs'
import { appDeleteSponsor, appGetAllSponsor } from '../../store/sponsor'
import { appGetAllSanstha } from '../../store/sanstha'
import PostPreview from '../../components/PostPreview/PostPreview'
import { toCamelCase } from '../../utils/Function'

function TableFilter() {
	const dispatch = useDispatch()
	const params = useParams()
	const navigate = useNavigate()
	const isloder = useSelector(state => state?.sponsorReducer.isloder)
	const paginate = useSelector(state => state.sponsorReducer.paginate)
	const isdeleted = useSelector(state => state?.sponsorReducer?.isdeleted)
	const sponsor = useSelector(state => state?.sponsorReducer.sponsor)
	const hub = useSelector(state => state?.hubReducer.hub)
	const sanstha = useSelector(state => state?.sansthaReducer.sanstha)
	const [page, setPage] = useState(params.page || 1)
	const [activeFilters, setActiveFilters] = useState({})
	const [selectedFilters, setSelectedFilters] = useState({
		sanstha: null,
		hub: null,
	})

	useEffect(() => {
		if (isdeleted) {
			const searchParams = {
				page,
				limit: 10,
			}
			const filters = {}

			if (selectedFilters.sanstha) {
				filters.sanstha = selectedFilters.sanstha.value
			}
			if (selectedFilters.hub) {
				filters.hub = [selectedFilters.hub.value]
			}

			dispatch(appGetAllSponsor(searchParams))
		}
	}, [isdeleted, dispatch])
	useEffect(() => {
		dispatch(appGetAllSanstha({ page: 1, limit: 1000, loading: false }))
		dispatch(appAllGetHubs({ page: 1, limit: 1000, loading: false }))
	}, [])
	// const formik = useFormik({
	// 	initialValues: {
	// 		hub: '',
	// 		sanstha: '',
	// 	},
	// 	onSubmit: values => {},
	// })

	const handleSansthaChange = option => {
		setSelectedFilters(prev => ({
			...prev,
			sanstha: option,
		}))
	}
	const handleHubChange = option => {
		setSelectedFilters(prev => ({
			...prev,
			hub: option,
		}))
		dispatch(appGetAllSanstha({ page: 1, limit: 1000, hub: option?.value }))
	}
	const handleDeleteSponsor = id => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this sponsor?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				dispatch(appDeleteSponsor(id))
			}
		})
	}

	useEffect(() => {
		const searchParams = {
			...activeFilters,
			page,
			limit: 10,
			admin: true,
		}
		dispatch(appGetAllSponsor(searchParams))
		navigate(`/sponsor/${page}`)
	}, [page, activeFilters])

	const handleSearch = useCallback(() => {
		let filters = { admin: true }
		const hasSanstha = !!selectedFilters.sanstha
		const hasHub = !!selectedFilters.hub

		if (hasSanstha && hasHub) {
			// Both selected: only sanstha
			filters.sanstha = selectedFilters.sanstha.value
		} else if (hasSanstha) {
			// Only sanstha
			filters.sanstha = selectedFilters.sanstha.value
		} else if (hasHub) {
			// Only hub
			filters.hub = selectedFilters.hub.value
		}
		setActiveFilters(filters)
		setPage(1)
	}, [selectedFilters])

	return (
		<>
			{isloder && <PageLoader />}
			<div className="card dataTables_wrapper">
				<div className="card-body">
					<div className="row">
						<div className="col-md-2">
							<div className="form-group">
								<label>Community</label>
								<Select
									options={
										Array.isArray(hub.data)
											? hub.data.map(hub => ({
													value: hub?._id,
													label: toCamelCase(hub?.name),
											  }))
											: []
									}
									onChange={handleHubChange}
									value={selectedFilters.hub}
									placeholder="Select Community.."
									getOptionLabel={option => option.label}
									getOptionValue={option => option.value}
								/>
							</div>
						</div>

						<div className="col-md-2">
							<div className="form-group">
								<label>Sanstha</label>
								<Select
									options={
										Array.isArray(sanstha)
											? sanstha.map(sanstha => ({
													value: sanstha?._id,
													label: toCamelCase(sanstha?.name),
											  }))
											: []
									}
									onChange={handleSansthaChange}
									value={selectedFilters.sanstha}
									placeholder="Select Sanstha.."
									getOptionLabel={option => option?.name || option?.label}
									getOptionValue={option => option?._id || option?.value}
								/>
							</div>
						</div>

						<div className="d-flex" style={{ alignItems: 'center', marginTop: '12px' }}>
							<button
								className="btn btn-primary mr-2"
								onClick={handleSearch}
								style={{ marginRight: '8px' }}
							>
								<em className="fas fa-search"></em> Search
							</button>
							<button
								className="btn btn-secondary"
								onClick={() => {
									setSelectedFilters({
										sanstha: null,
										hub: null,
									})
									setActiveFilters({ admin: true })
									setPage(1)
									dispatch(appGetAllSponsor({ page: 1, limit: 10, admin: true }))
								}}
							>
								<em className="fas fa-redo"></em> Reset
							</button>
						</div>
					</div>

					<div className="table-responsive bootgrid mt-3">
						<table className="table table-hover" id="bootgrid-command">
							<thead>
								<tr>
									<th>Sponsor Image</th>
									<th>Sponsor Name</th>
									<th data-column-id="received" data-order="desc">
										Sanstha
									</th>
									<th data-column-id="received" data-order="desc">
										Community
									</th>

									<th data-column-id="received" data-order="desc">
										Paid Amount (Rs)
									</th>
								</tr>
							</thead>
							<tbody>
								{sponsor &&
									sponsor.map((value, index) => (
										<tr key={index}>
											<PostPreview value={value?.image || '/img/user.jpg'} />

											<td>
												<PostPreview value={value?.user?.profilePic || '/img/user.jpg'} />

												{value?.user?.firstName}
												{value?.user?.lastName}
											</td>
											<td>
												<PostPreview value={value?.sanstha?.image} />
												{value?.sanstha?.name}
											</td>
											<td>
												<PostPreview value={value?.hub?.image} />
												{/* <span
													className="text-truncate d-inline-block"
													style={{ maxWidth: '150px' }}
												> */}
												{value?.hub?.name}
												{/* </span> */}
											</td>
											<td>{value?.amount || 0}</td>
											<td>
												<button
													type="button"
													className="btn btn-sm btn-info mr-2 command-edit"
													onClick={() =>
														navigate(`/sponsor/edit/${value?._id}`, {
															state: { sponsor: value },
														})
													}
												>
													<em className="fa fa-edit fa-fw"></em>
												</button>

												<button
													type="button"
													className="btn btn-sm btn-danger command-delete"
													onClick={() => handleDeleteSponsor(value?._id)}
												>
													<em className="fa fa-trash fa-fw"></em>
												</button>
											</td>
										</tr>
									))}
							</tbody>
						</table>
					</div>
					{paginate && <Paginate paginate={paginate} page={page} setPage={setPage} />}
				</div>
			</div>
		</>
	)
}

export default TableFilter
